import useInitializeMatrix from 'contexts/MatrixContext/useInitializeMatrix';

const InitializeMatrix = () => {
  useInitializeMatrix();

  return null;
};

export default InitializeMatrix;
